const actionType = {

    FACILITY_REGISTER_SUCCESS : "FACILITY_REGISTER_SUCCESS",
    FACILITY_REGISTER_FAILURE : "FACILITY_REGISTER_FAILURE",

    FACILITY_SEND_OTP_SUCCESS : "FACILITY_SEND_OTP_SUCCESS",
    FACILITY_SEND_OTP_FAILURE :"FACILITY_SEND_OTP_FAILURE",
    
    FACILITY_CONFIRM_OTP_SUCCESS : "FACILITY_CONFIRM_OTP_SUCCESS",
    FACILITY_CONFIRM_OTP_FAILURE :"FACILITY_CONFIRM_OTP_FAILURE",

    REMOTE_ACCESS_VPN_SUCCESS : "REMOTE_ACCESS_VPN_SUCCESS",
    REMOTE_ACCESS_VPN_FAILURE : "REMOTE_ACCESS_VPN_FAILURE",

    GET_CLOUD_BASE_EMR_VPN_SUCCESS : "GET_CLOUD_BASE_EMR_VPN_SUCCESS",
    GET_CLOUD_BASE_EMR_VPN_FAILURE : "GET_CLOUD_BASE_EMR_VPN_FAILURE",

    SAVE_CLOUD_BASE_EMR_SUCCESS : "SAVE_CLOUD_BASE_EMR_SUCCESS",
    SAVE_CLOUD_BASE_EMR_FAILURE : "SAVE_CLOUD_BASE_EMR_FAILURE",

    ADD_CLOUD_BASE_EMR_SUCCESS : "ADD_CLOUD_BASE_EMR_SUCCESS",
    ADD_CLOUD_BASE_EMR_FAILURE : "ADD_CLOUD_BASE_EMR_FAILURE",

    GET_REMOTE_ACCESS_VPN_SUCCESS : "GET_REMOTE_ACCESS_VPN_SUCCESS",
    GET_REMOTE_ACCESS_VPN_FAILURE : "GET_REMOTE_ACCESS_VPN_FAILURE",

    SAVE_REMOTE_VPN_SUCCESS : "SAVE_REMOTE_VPN_SUCCESS",
    SAVE_REMOTE_VPN_FAILURE : "SAVE_REMOTE_VPN_FAILURE",

    UPDATE_REMOTE_ACCESS_VPN_SUCCESS : "UPDATE_REMOTE_ACCESS_VPN_SUCCESS",
    UPDATE_REMOTE_ACCESS_VPN_FAILURE : "UPDATE_REMOTE_ACCESS_VPN_FAILURE",
    
    ADD_PRACTITIONERS_SUCCESS : "ADD_PRACTITIONERS_SUCCESS",
    ADD_PRACTITIONERS_FAILURE : "ADD_PRACTITIONERS_FAILURE",

    GET_PRACTITIONERS_SUCCESS : "GET_PRACTITIONERS_SUCCESS",
    GET_PRACTITIONERS_FAILURE : "GET_PRACTITIONERS_FAILURE",

    EDIT_PRACTITIONER_SUCCESS : "EDIT_PRACTITIONER_SUCCESS",
    EDIT_PRACTITIONER_FAILURE : "EDIT_PRACTITIONER_FAILURE",

    DELETE_PRACTITIONER_SUCCESS : "DELETE_PRACTITIONER_SUCCESS",
    DELETE_PRACTITIONER_FAILURE : "DELETE_PRACTITIONER_FAILURE",

    EMAIL_BAA_DOC_SUCCESS : "EMAIL_BAA_DOC_SUCCESS",
    EMAIL_BAA_DOC_FAILURE : "EMAIL_BAA_DOC_FAILURE",

    FACILITY_REQ_LIST_SUCCESS : "FACILITY_REQ_LIST_SUCCESS",
    FACILITY_REQ_LIST_FAILURE : "FACILITY_REQ_LIST_FAILURE",
 
    SAVE_REG_DATA : "SAVE_REG_DATA",
    SAVE_REG_DATA_STATUS_CHANGE  :"SAVE_REG_DATA_STATUS_CHANGE",

    STATUS_CHANGE_FINAL_REG : "STATUS_CHANGE_FINAL_REG",

    VERIFY_SERVICE_SUCCESS :"VERIFY_SERVICE_SUCCESS",
    VERIFY_SERVICE_FAILURE :"VERIFY_SERVICE_FAILURE",

    FACILITY_SELECT_TYPE_SUCCESS : "FACILITY_SELECT_TYPE_SUCCESS",
    FACILITY_SELECT_TYPE_FAILURE  : "FACILITY_SELECT_TYPE_FAILURE",

    FACILITY_CREATE_UPDATE_SELECTED_SUCCESS : "FACILITY_CREATE_UPDATE_SELECTED_SUCCESS",
    FACILITY_CREATE_UPDATE_SELECTED_FAILURE : "FACILITY_CREATE_UPDATE_SELECTED_FAILURE",

    APPROVE_FACILITY_SUCCESS : "APPROVE_FACILITY_SUCCESS",
    APPROVE_FACILITY_FAILURE : "APPROVE_FACILITY_FAILURE",

    DECLINE_FACILITY_SUCCESS : "DECLINE_FACILITY_SUCCESS",
    DECLINE_FACILITY_FAILURE : "DECLINE_FACILITY_FAILURE",

  };
  export default actionType;
    